import styled, { css } from "styled-components";
import { INLINE_ICON_IMAGE_CLASS, INLINE_ICON_SIZE_PX, InlineIconSizeCode } from "./DefaultConfig";

export const StyledIconWrapper = styled.span`
  display: inline-block;
  vertical-align: middle;
  padding: 0 4px;
`;

const inlineIconImageSizeStyles = (sizeCode: InlineIconSizeCode) => {
  const sizePx = INLINE_ICON_SIZE_PX[sizeCode];

  return css`
    width: ${sizePx}px !important;
    max-height: ${sizePx}px !important;
  `;
};

export const IconContainer = styled.span`
  /* BV's v1 IconContainer is a plain inline (baseline-aligned); only the inner
     wrapper is inline-block + middle. inline-block/middle here compounds the
     centering and drops the icon ~2px below BV's position */
  font-size: inherit;
  text-decoration: none;
  cursor: pointer;
  pointer-events: none;

  &.spf-inline-icon .${INLINE_ICON_IMAGE_CLASS} {
    object-fit: contain;
  }

  &.spf-inline-icon .${INLINE_ICON_IMAGE_CLASS}--S {
    ${inlineIconImageSizeStyles("S")}
  }

  &.spf-inline-icon .${INLINE_ICON_IMAGE_CLASS}--M {
    ${inlineIconImageSizeStyles("M")}
  }

  &.spf-inline-icon .${INLINE_ICON_IMAGE_CLASS}--L {
    ${inlineIconImageSizeStyles("L")}
  }

  &.spf-inline-icon .${INLINE_ICON_IMAGE_CLASS}--XL {
    ${inlineIconImageSizeStyles("XL")}
  }
`;

export function getInlineIconImageClassName(sizeCode: InlineIconSizeCode): string {
  return `${INLINE_ICON_IMAGE_CLASS} ${INLINE_ICON_IMAGE_CLASS}--${sizeCode}`;
}
